export const fontSansSerif = `"Open Sans", "Segoe UI", Tahoma, sans-serif`;
